import { css } from "@emotion/css";

export const getAudioStyles = (primaryColor: string = "#493AB1") => ({
  container: css({
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
    padding: "6px 16px 12px 16px",
    boxSizing: "border-box",
  }),
  audioRow: css({
    display: "flex",
    alignItems: "center",
    width: "100%",
    position: "relative",
  }),
  playerWrapper: css({
    width: "100%",
    display: "flex",
    alignItems: "center",
    "& > div": {
      width: "100%",
      display: "flex",
      alignItems: "center",
    },
  }),
  playbackCta: css({
    color: `${primaryColor} !important`,
    padding: "0px !important",
    marginRight: "8px !important",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    "&:hover": {
      opacity: 0.85,
    },
    "& svg": {
      fontSize: "36px !important",
      width: "36px",
      height: "36px",
      fill: "currentColor",
    },
  }),
  audioSurfer: css({
    width: "100% !important",
    flex: "1 1 auto",
    minWidth: 0,
    cursor: "pointer",
  }),
  audioDuration: css({
    color: "#555 !important",
    fontSize: "13px",
    fontWeight: 500,
    paddingLeft: "12px",
    fontVariantNumeric: "tabular-nums",
    margin: 0,
    whiteSpace: "nowrap",
    flexShrink: 0,
  }),
  fallbackWaveContainer: css({
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "8px",
  }),
  fallbackWaveSurfer: css({
    flex: 1,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    minWidth: 0,
  }),
  removeButton: css({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    background: "transparent",
    border: "none",
    color: "#9ca3af",
    transition: "all 0.15s ease",
    flexShrink: 0,
    marginLeft: "8px",
    "&:hover": {
      background: "rgba(239, 68, 68, 0.1)",
      color: "#ef4444",
    },
  }),
});
